import React from "react";
import BlogContent from "../components/blog/content";
import BlogSidebar from "../components/blog/sidebar";
import Seo from "../components/common/seo";

const Article = ({ pageContext }) => {
  const { blog, recentData, heading } = pageContext;

  return (
    <div className="blogpage container">
      <div className="left">
        <BlogContent data={blog} />
      </div>
      <div className="right">
        <BlogSidebar
          author={blog.author}
          recentData={recentData}
          heading={heading}
          iframes={[
            "99ab7f8c-97af-47c3-a7ef-8c7933413bfc",
            "99ab7fc9-d6ef-481f-9f53-bc0d473529b5",
          ]}
        />
      </div>
    </div>
  );
};

export function Head({ location, pageContext }) {
  const { blog } = pageContext;
  const seoData = {
    title: blog?.title,
    description: blog?.description,
    image: blog?.image,
  };

  return <Seo location={location} data={seoData} />;
}

export default Article;
